import React from 'react';
import { Grid, Typography, Select, MenuItem, ListItemIcon, ListItemText, FormControl, InputLabel } from '@mui/material';
import { BsFillBarChartLineFill } from 'react-icons/bs';
import { BiLineChart } from 'react-icons/bi';
import { MdOutlineSpeed } from 'react-icons/md';
import { AutoAwesome } from '@mui/icons-material';

const MetricsDropdown = ({ showMetrics, setshowMetrics, CONFIG_APP_BASE_COMPANY, repoUrl }) => {

  const options = [
    {
      value: 'system',
      label: 'System Performance',
      icon: <BsFillBarChartLineFill style={{ fontSize: '20px', color: '#00d7ff' }} />,
    },
    {
      value: 'forecast',
      label: 'Resource Usage Forecast',
      icon: <AutoAwesome style={{ fontSize: '20px', color: '#ba8aff' }} />,
    },
    {
      value: 'uptime',
      label: 'Uptime Status',
      icon: <BiLineChart style={{ fontSize: '20px', color: '#5cdd8b' }} />,
    },
  ];

  if (CONFIG_APP_BASE_COMPANY === 'nife') {
    options.push({
      value: 'dns',
      label: 'DNS',
      icon: (
        <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" height="20px" width="20px" xmlns="http://www.w3.org/2000/svg" style={{ color: '#02d1b4' }}>
          <path d="M21 12a9 9 0 1 0 -9 9"></path>
          <path d="M3.6 9h16.8"></path>
          <path d="M3.6 15h8.4"></path>
          <path d="M11.578 3a17 17 0 0 0 0 18"></path>
          <path d="M12.5 3c1.719 2.755 2.5 5.876 2.5 9"></path>
          <path d="M18 21v-7m3 3l-3 -3l-3 3"></path>
        </svg>
      ),
    });
    options.push({
      value: 'speed',
      label: 'Speed Insights',
      icon: <MdOutlineSpeed style={{ fontSize: '20px', color: '#DA70D6' }} />,
    });
  }

  if (repoUrl !== "") {
    options.push({
      value: 'dora',
      label: 'DORA metrics',
      icon: (
        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="20px" width="20px" xmlns="http://www.w3.org/2000/svg" style={{ color: '#fc8c00' }}>
          <path d="M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-6.333 13a1 1 0 0 0 -1 1v2l.007 .117a1 1 0 0 0 1.993 -.117v-2l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 -4a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 2a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z"></path>
        </svg>
      ),
    });
  }

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} md={9}>
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
          App Metrics
        </Typography>
      </Grid>

      <Grid item xs={12} md={3}>
        <FormControl fullWidth size="small">
          <InputLabel id="metrics-select-label">Select Metric</InputLabel>
      <Select
  labelId="metrics-select-label"
  value={showMetrics}
  label="Select Metric"
  onChange={(e) => setshowMetrics(e.target.value)}
  renderValue={(selected) => {
    const option = options.find(opt => opt.value === selected);
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {option?.icon}
        <span style={{ marginLeft: '8px' }}>{option?.label}</span>
      </div>
    );
  }}
>
  {options.map((option) => (
    <MenuItem key={option.value} value={option.value}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {option.icon}
        <span style={{ marginLeft: '8px' }}>{option.label}</span>
      </div>
    </MenuItem>
  ))}
</Select>

        </FormControl>
      </Grid>
    </Grid>
  );
};

export default MetricsDropdown;
